import { Check, X } from 'lucide-react';

const ramba = [
  'سعر ثابت شهري',
  'تابع دورك من تطبيقك',
  'أي مغسلة شريكة',
  'إشعار لما سيارتك تجهز',
];

const others = [
  'تدفع كل مرة',
  'لازم تنتظر بالمكان',
  'مغسلة وحدة بس',
  'لازم تتصل أو تروح تشيك',
];

export default function WhySection() {
  return (
    <section className="py-16 md:py-24 px-4 bg-surface">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-text-brand font-cairo text-center mb-12 md:mb-16 anim-fade-up">
          ليش رمبا؟
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
          {/* Ramba Column */}
          <div className="rounded-3xl p-6 md:p-8 border-2 border-green-200 bg-green-50 hover:border-green-300 transition-all anim-fade-up delay-1">
            <h3 className="text-xl font-extrabold text-green-700 text-center mb-6 font-cairo">رمبا</h3>
            <ul className="flex flex-col gap-4">
              {ramba.map((item) => (
                <li key={item} className="flex items-center gap-3 text-text-brand">
                  <Check className="w-5 h-5 text-green-600 shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Others Column */}
          <div className="rounded-3xl p-6 md:p-8 border-2 border-red-200 bg-red-50 hover:border-red-300 transition-all anim-fade-up delay-2">
            <h3 className="text-xl font-extrabold text-red-700 text-center mb-6 font-cairo">المغاسل العادية</h3>
            <ul className="flex flex-col gap-4">
              {others.map((item) => (
                <li key={item} className="flex items-center gap-3 text-text-brand">
                  <X className="w-5 h-5 text-red-500 shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
